/**
 * Settings Actions
 * Action creators לעדכון הגדרות דשבורד
 */

// ============================================
// Action Creators
// ============================================

export const updateDashboardSettingsAction = (settings) => ({
    type: 'UPDATE_DASHBOARD_SETTINGS',
    payload: { settings }
});

// ============================================
// Thunk Action - Dashboard Settings
// ============================================

/**
 * updateDashboardSettings - עדכון הגדרות דשבורד
 * @param {Object} settings - הגדרות חדשות { bgColor, bgImage }
 */
export const updateDashboardSettings = (settings) => (dispatch) => {
    console.log('⚙️ Updating dashboard settings:', settings);
    dispatch(updateDashboardSettingsAction(settings));
    return { success: true };
};
